import { catchError, from, map, Observable, tap } from "rxjs";
import { AdminStats } from "../../models/stats/admin-stats.model";
import { StoreService } from "..";
import { AdminStatsApiService } from "../../services/api/admin-stats-api.service";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class AdminStatsService {

  constructor(
    private store: StoreService,
    private adminStatsApiService: AdminStatsApiService
  ) { }

  get adminStats$(): Observable<AdminStats | null> {
    return this.store.state$.pipe(map(state => state.adminStats));
  }

  load(): Observable<AdminStats> {
    this.store.setState({ ...this.store.state, loading: true, error: null });
    return from(this.adminStatsApiService.getAdminStats()).pipe(
      tap(adminStats => {
        this.store.setState({
          ...this.store.state,
          adminStats
        });
      }),
      catchError((error) => {
        this.store.setState({ ...this.store.state, loading: false, error });
        console.error('Error loading admin stats:', error);
        throw error;
      })
    );
  }

  clear(): void {
    const state = { ...this.store.state };
    state.adminStats = null;
    this.store.setState(state);
  }
}